module.exports = __webpack_public_path__ + "media/images/core_values/positivity-b12f4a96045e60e960d93b6b64ee8c58.png";